import { Helmet } from "react-helmet";
import DigitalStudioLayout from "../sections/digitalStudio/digitalStudioLayout";

const DigitalStudioPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x Digital Studio | Creative AI, Games & Tech Solutions</title>
                <meta name="description" content="At code3x Digital Studio, we blend creativity and technology to design impactful digital experiences." />
                <meta name="keywords" content="code3x digital studio, creative workspace, AI innovation, gaming design studio, digital solutions hub" />
                <link rel="canonical" href="https://code3x.tech/digital-studio" />
            </Helmet>

            <DigitalStudioLayout />
        </>
    );
}

export default DigitalStudioPage;